import $ from 'jquery';
import Highcharts from 'highcharts/es-modules/masters/highcharts.src';
import 'highcharts/es-modules/masters/modules/accessibility.src';
import 'highcharts/es-modules/masters/modules/exporting.src';
import 'highcharts/es-modules/masters/modules/offline-exporting.src';

(function () {
  const AnnualReportingJson = window.AnnualReportingJson;

  if (typeof AnnualReportingJson !== 'undefined') {
    function zeroCleaned (series) {
      series[0].data.forEach(function (datum, i) {
        if (datum.y <= 0) {
          series[0].data.splice(i, 1);
        }
      });

      return series;
    }

    function chartObj (chartSeries, chartTitle) {
      return {
        chart: {
          backgroundColor: null,
          type: 'pie',
        },
        colors: [
          '#4572A7', // Blue
          '#AA4643', // Red
          '#89A54E', // Green
          '#80699B', // Purple
          '#3D96AE', // Teal
          '#DB843D', // Orange
          '#A47D7C', // Brown
          '#B5CA92', // Light Green
          '#92A8CD', // Light Blue
          '#D0C7DA', // Light Purple
          '#EAB890', // Light Orange
          '#E9C8D8', // Light Pink
        ],
        title: {
          text: chartTitle
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        legend: {
          itemWidth: 200,
          itemMarginBottom: 3,
          itemStyle: {
            fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true,
            size: 200
          }
        },
        series: zeroCleaned(chartSeries),
        credits: {
          enabled: true
        },
        lang: {
          download_key: 'Download'
        },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                'downloadPNG',
                'downloadPDF',
              ],
            },
          }
        }
      }
    }

    function addDelimiter(nStr){
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    }

    var petSav = [{
      name: 'Savings',
      // Keep chart sections in sync with annual reporting charts:
      // https://github.nlr.gov/TADA/cleancities-survey/blob/f9390a1f6c156ffdcffd954ad070aaee7f8a775a/app/controllers/reports_controller.rb#L7-L24
      // Note, there may be delays or differences in the exact logic, since it
      // depends on what year of data is being pulled in (see
      // `CoalitionsController::ANNUAL_REPORT_DATA_YEAR`).
      data: [{
        name: "Alternative Fuel Vehicles",
        y: AnnualReportingJson.association_totals.afvs_fuel_blends.gge_reduced_doe
      }, {
        name: "Fuel Economy Improvements",
        y: AnnualReportingJson.association_totals.fuel_economy_improvements.gge_reduced_doe
      }, {
        name: "Idle Reductions",
        y: AnnualReportingJson.association_totals.idle_reductions.gge_reduced_doe
      }, {
        name: "Off Road Vehicles",
        y: AnnualReportingJson.association_totals.off_road_vehicles.gge_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.association_totals.electrics_evs_phevs.gge_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.association_totals.electrics_hevs.gge_reduced_doe
      }, {
        name: "Vehicle Miles Traveled Reductions",
        y: AnnualReportingJson.association_totals.vmt_reductions.gge_reduced_doe
      }]
    }];

    Highcharts.chart('pet-sav', chartObj(petSav, 'Annual Petroleum Savings'));

    var petSavTotal = AnnualReportingJson.association_totals.gge_reduced_doe_total;

    $('#pet-sav-total').text(addDelimiter(Math.round(petSavTotal)) + ' gasoline gallon equivalents');

    var petSavByProj = [{
      name: 'Savings',
      // Keep chart sections in sync with annual reporting charts:
      // https://github.nlr.gov/TADA/cleancities-survey/blob/f9390a1f6c156ffdcffd954ad070aaee7f8a775a/app/controllers/reports_controller.rb#L46-L68
      // Note, there may be delays or differences in the exact logic, since it
      // depends on what year of data is being pulled in (see
      // `CoalitionsController::ANNUAL_REPORT_DATA_YEAR`).
      data: [{
        name: "Biodiesel",
        y: AnnualReportingJson.afv_fuel_totals.biodiesel.gge_reduced_doe
      }, {
        name: "Natural Gas (CNG)",
        y: AnnualReportingJson.afv_fuel_totals.CNG.gge_reduced_doe
      }, {
        name: "Ethanol (E85)",
        y: AnnualReportingJson.afv_fuel_totals.E85.gge_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.electricity.gge_reduced_doe + AnnualReportingJson.afv_fuel_totals.PHEV.gge_reduced_doe + AnnualReportingJson.afv_fuel_totals["EV-PHEV"].gge_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.HEV.gge_reduced_doe
      }, {
        name: "Hydrogen",
        y: AnnualReportingJson.afv_fuel_totals.H2.gge_reduced_doe
      }, {
        name: "Liquefied Natural Gas",
        y: AnnualReportingJson.afv_fuel_totals.LNG.gge_reduced_doe
      }, {
        name: "Propane (LPG)",
        y: AnnualReportingJson.afv_fuel_totals.LPG.gge_reduced_doe
      }, {
        name: "Renewable Natural Gas",
        y: AnnualReportingJson.afv_fuel_totals.renewable_ng.gge_reduced_doe
      }, {
        name: "Renewable Diesel",
        y: AnnualReportingJson.afv_fuel_totals.renew_diesel.gge_reduced_doe
      }]
    }];

    Highcharts.chart('pet-sav-by-proj', chartObj(petSavByProj, 'Annual Petroleum Savings by Alternative Fuel Vehicle Project Type'));

    var petSavByProjTotal = AnnualReportingJson.afv_fuel_totals.totals.gge_reduced_doe;

    $('#pet-sav-by-proj-total').html(addDelimiter(Math.round(petSavByProjTotal)) + ' gasoline gallon equivalents');

    var greenGasAvoided = [{
      name: 'Avoided',
      // Keep chart sections in sync with annual reporting charts:
      // https://github.nlr.gov/TADA/cleancities-survey/blob/f9390a1f6c156ffdcffd954ad070aaee7f8a775a/app/controllers/reports_controller.rb#L7-L24
      // Note, there may be delays or differences in the exact logic, since it
      // depends on what year of data is being pulled in (see
      // `CoalitionsController::ANNUAL_REPORT_DATA_YEAR`).
      data: [{
        name: "Alternative Fuel Vehicles",
        y: AnnualReportingJson.association_totals.afvs_fuel_blends.ghg_reduced_doe
      }, {
        name: "Fuel Economy Improvements",
        y: AnnualReportingJson.association_totals.fuel_economy_improvements.ghg_reduced_doe
      }, {
        name: "Idle Reductions",
        y: AnnualReportingJson.association_totals.idle_reductions.ghg_reduced_doe
      }, {
        name: "Off Road Vehicles",
        y: AnnualReportingJson.association_totals.off_road_vehicles.ghg_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.association_totals.electrics_evs_phevs.ghg_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.association_totals.electrics_hevs.ghg_reduced_doe
      }, {
        name: "Vehicle Miles Traveled Reductions",
        y: AnnualReportingJson.association_totals.vmt_reductions.ghg_reduced_doe
      }]
    }];

    Highcharts.chart('green-gas-avoided', chartObj(greenGasAvoided, 'Annual Greenhouse Gas Emission Avoided'));

    var greenGasAvoidedTotal = AnnualReportingJson.association_totals.ghg_reduced_doe_total;

    $('#green-gas-avoided-total').html(addDelimiter(Math.round(greenGasAvoidedTotal)) + ' tons of carbon dioxide-equivalent (CO2e)');

    var greenGasByProj = [{
      name: 'Avoided',
      // Keep chart sections in sync with annual reporting charts:
      // https://github.nlr.gov/TADA/cleancities-survey/blob/f9390a1f6c156ffdcffd954ad070aaee7f8a775a/app/controllers/reports_controller.rb#L46-L68
      // Note, there may be delays or differences in the exact logic, since it
      // depends on what year of data is being pulled in (see
      // `CoalitionsController::ANNUAL_REPORT_DATA_YEAR`).
      data: [{
        name: "Biodiesel",
        y: AnnualReportingJson.afv_fuel_totals.biodiesel.ghg_reduced_doe
      }, {
        name: "Natural Gas (CNG)",
        y: AnnualReportingJson.afv_fuel_totals.CNG.ghg_reduced_doe
      }, {
        name: "Ethanol (E85)",
        y: AnnualReportingJson.afv_fuel_totals.E85.ghg_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.electricity.ghg_reduced_doe + AnnualReportingJson.afv_fuel_totals.PHEV.ghg_reduced_doe + AnnualReportingJson.afv_fuel_totals["EV-PHEV"].ghg_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.HEV.ghg_reduced_doe
      }, {
        name: "Hydrogen",
        y: AnnualReportingJson.afv_fuel_totals.H2.ghg_reduced_doe
      }, {
        name: "Liquefied Natural Gas",
        y: AnnualReportingJson.afv_fuel_totals.LNG.ghg_reduced_doe
      }, {
        name: "Propane (LPG)",
        y: AnnualReportingJson.afv_fuel_totals.LPG.ghg_reduced_doe
      }, {
        name: "Renewable Natural Gas",
        y: AnnualReportingJson.afv_fuel_totals.renewable_ng.ghg_reduced_doe
      }, {
        name: "Renewable Diesel",
        y: AnnualReportingJson.afv_fuel_totals.renew_diesel.ghg_reduced_doe
      }]
    }];

    Highcharts.chart('green-gas-by-proj', chartObj(greenGasByProj, 'Greenhouse Gas Emission Reduced by Alternative Fuel Vehicle Project Type'));

    var greenGasByProjTotal = AnnualReportingJson.afv_fuel_totals.totals.ghg_reduced_doe;

    $('#green-gas-by-proj-total').html(addDelimiter(Math.round(greenGasByProjTotal)) + ' tons of CO2e');
  }

  $('.video-div').click(function () {
    $('.videos').addClass('d-none');

    var videoId = $(this).prop('id').split('-')[2];
    $('#video-' + videoId).removeClass('d-none');
  });
})();
